import { render } from "./QuestionnairePeriodComponent.vue?vue&type=template&id=348e051f&scoped=true&ts=true"
import script from "./QuestionnairePeriodComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionnairePeriodComponent.vue?vue&type=script&lang=ts"

import "./QuestionnairePeriodComponent.vue?vue&type=style&index=0&id=348e051f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348e051f"]])

export default __exports__